import(/* webpackMode: "eager" */ "/home/web/PaperDB_V2_next-a/app/global-error.tsx");
